import React from "react";
import Headline from "./Headline";
import PostsApi from "../../api-services/posts-api.service";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const bannerPath = '/iceholidays-assets/images/news&blogs_cover.png';
const categoryLabel = {
  "news_and_events": "News",
  "blog": "Blog"
}

function withParams(Component) {
  return props => <Component {...props} params={useParams()} searchParams={useSearchParams()}/>;
}

class BlogShowPage extends React.Component <{params, searchParams}>  {
  postsApi = new PostsApi;

  state = {
    breadcrumbs: [
      { title: <Link to='/web'>Home</Link> },
      { title: <Link to='/web/blogs'>News</Link> }
    ],
    header: 'Blog',
    blog: {title: "", thumbnail: "", content: ""},
  }

  componentDidMount() {
    var breadcrumbs = this.state.breadcrumbs;
    const [searchParams] = this.props.searchParams;

    this.postsApi.getPost(this.props.params.id)
      .then(blogData => {
        const type = searchParams.get('type');
        if(type){
          const category = categoryLabel[type];
          breadcrumbs.push({title: <span>{blogData.title}</span>});
          this.setState({breadcrumbs, header: category})
        }
        this.setState({blog: blogData, breadcrumbs})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading blog.'});
      });
  }


  render(){
    const {blog, header} = this.state;
    return (
      <div id="news-blogs-show" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={this.state.breadcrumbs}>
          <span className="title">
            {header}
          </span>
        </Headline>

        <div className="gd-series-tour-show-page_body">
          <h1>{blog.title}</h1>
          <img src={blog.thumbnail}/>
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
    )
  }
}


export default withParams(BlogShowPage);